<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="物料链接" label-width="80px">
          <el-input v-model.trim="form.wanpanUrl" type="textarea" placeholder="填入网盘链接或在下方上传物料相关文件" class="wanpan"></el-input>
          <material-upload :file-list.sync="form.trackFileList"></material-upload>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="歌单信息" label-width="80px">
          <material-upload :file-list.sync="form.songlistFileList"></material-upload>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="授权文件" label-width="80px">
          <material-upload :file-list.sync="form.authFileList"></material-upload>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item label="艺人名" label-width="80px">
          <el-input v-model.trim="form.singerName" placeholder="请输入" class="form-field"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="上线时间" label-width="80px">
          <el-date-picker
            v-model="form.onlineTime"
            style="width: 200px;"
            type="datetime"
            default-time="23:59:59"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="备注" prop="remarks" label-width="80px">
      <el-input type="textarea" v-model="form.remarks" :rows="5" placeholder="请输入"></el-input>
    </el-form-item>
    <replace-material-list :replace-list="form.replaceAudioList"></replace-material-list>
  </div>
</template>

<script>
import MaterialUpload from './MaterialUpload.vue'
import ReplaceMaterialList from './ReplaceMaterialList.vue'

export default {
  name: 'MaterialItem',
  components: {
    MaterialUpload,
    ReplaceMaterialList
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: null
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler() {
        this.form = this.data
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.wanpan {
  margin-bottom: 10px;
}
</style>
